import getHostDomain from '@/state/selectors/options/get-host-domain';
import store from '@/state/vanilla';

const normalisePath = (path?: string): string | undefined => {
	if (!path) return undefined;

	const state = store.getState();
	const hostDomain = getHostDomain(state);

	if (!hostDomain) return path;

	const isCompletePath =
		path.startsWith('http://') || path.startsWith('https://');

	if (isCompletePath) return path;

	const isAbsolutePath = path.startsWith('/');
	const hostDomainWithSlash = hostDomain.endsWith('/');

	if (isAbsolutePath && hostDomainWithSlash) {
		return `${hostDomain}${path.slice(1)}`;
	}

	if (isAbsolutePath && !hostDomainWithSlash) {
		return `${hostDomain}/${path.slice(1)}`;
	}

	if (!isAbsolutePath && hostDomainWithSlash) {
		return `${hostDomain}${path}`;
	}

	return `${hostDomain}/${path}`;
};

export default normalisePath;
